import { memo, useContext, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import LoadingPage from '../../components/LoadingSpinner/LoadingPage';
import { AuthContext } from '../../contexts/AuthContext/AuthContext';

function Impersonate() {
  const { impersonate } = useContext(AuthContext);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      impersonate(id).then(() => {
        navigate('/');
      });
    }
  }, []);

  return <LoadingPage />;
}

export default memo(Impersonate);
